import CRCReelCascadeBehaviour from '../src/spinner/CRCReelCascadeBehaviour'
import Reel from "../../vendor_core/core/src/views/Reel";
import ReelSymbol from "../../vendor_core/core/src/views/Symbol";
import GameFactory from "../../vendor_core/src/factories/GameFactory";
import CCCascadeReelGroup from "./view/CCCascadeReelGroup";
import CRCAnticipation from "./view/CRCAnticipation";
import CRCUIView from "./view/CRCUIView";
import CCWinSymbolsView from "./view/CCWinSymbolsView";
import CRCWinlinesView from "./view/CRCWinlinesView";
import CRSettings from './view/CRSettings';
import BaseSettings from "../../vendor_core/core/src/ui/BaseSettings";

/**
 * Factory for creating game specific objects
 */
class CRCGameFactory extends GameFactory {

    protected getAnticipation(): CRCAnticipation {
        return new CRCAnticipation();
    }

    protected getWinSymbolsView(): CCWinSymbolsView {
        return new CCWinSymbolsView();
    }

    protected getWinlinesView(): CRCWinlinesView {
        return new CRCWinlinesView();
    }

    protected getReelGroup(): CCCascadeReelGroup {
        return new CCCascadeReelGroup();
    }

    protected getUIView(): CRCUIView {
        return new CRCUIView();
    }

    protected getSymbol(): ReelSymbol {
        return new ReelSymbol();
    }

    protected getSettings(): BaseSettings {
        return new CRSettings();
    }

    protected getFreeSpinBehaviour(params: { reel: Reel; sortFunction: any }): CRCReelCascadeBehaviour {
        return new CRCReelCascadeBehaviour(params.reel, params.sortFunction);
    }

    protected getRespinBehaviour(params: { reel: Reel; sortFunction: any }): CRCReelCascadeBehaviour {
        return new CRCReelCascadeBehaviour(params.reel, params.sortFunction);
    }

    protected getSpinBehaviour(params: { reel: Reel; sortFunction: any }): CRCReelCascadeBehaviour {
        return new CRCReelCascadeBehaviour(params.reel, params.sortFunction);
    }
}

export default CRCGameFactory;
